module.exports = __webpack_public_path__ + "static/assets/241ad769cabf379fde4d1bf64aa06a8a.png";